import { effectiveSets, estimateWorkoutMinutes } from "@liftquest/shared/plan-logic";
import type { ExerciseType, Phase } from "@liftquest/shared/types";

type PlannedExercise = {
  sets: number;
  targetMax: number;
  restSec: number;
  warmupSets: number;
  exercise: { type: ExerciseType };
};

/** Estimated minutes of a workout in the given phase (with the plan's general warm-up, if it has one). */
export function workoutMinutes(exercises: PlannedExercise[], phase: Phase | null, warmup: boolean) {
  return estimateWorkoutMinutes(
    exercises.map((we, i) => ({
      type: we.exercise.type,
      sets: effectiveSets(we.sets, i, phase),
      targetMax: we.targetMax,
      restSec: we.restSec,
      warmupSets: we.warmupSets,
    })),
    { warmup },
  );
}
